// src/components/TermItem.js
import React from 'react';

const TermItem = ({ term, onTermClick }) => {
  return (
    <div
      className="border border-gray-200 p-4 mb-3 rounded-lg shadow-sm cursor-pointer hover:bg-gray-100 transition-colors duration-150 ease-in-out"
      onClick={() => onTermClick(term)}
    >
      <h3 className="text-xl font-semibold text-blue-700 mb-1">{term.term}</h3>
      <p className="text-sm text-gray-600">カテゴリ: {term.category}</p>
    </div>
  );
};

export default TermItem;